
import { useState } from "react";

import type { ProductionWorkspacePlanRow, ProductionWorkspaceReport } from "../../../shared/production/workspace-report";
import {ProductionLotCostWorkspace} from "./ProductionLotCostWorkspace";

import { ProductionRecipeCostWorkspace } from "./ProductionRecipeCostWorkspace";

type Props={from:string;to:string;refreshVersion:number;planRows:ProductionWorkspacePlanRow[];planLabel:string|null;planBasis:ProductionWorkspaceReport["dailyPlanBasis"]};

export function ProductionMaterialCostWorkspace(props: Props) {
  const [mode, setMode] = useState<"recipe" | "lot">("recipe");
  return <div>
    <div className="pw-switch pmc-mode-switch" aria-label="Maliyet hesaplama yöntemi">
      <button type="button" aria-pressed={mode === "recipe"} onClick={() => setMode("recipe")}>Ürün reçetesinden birim maliyet</button>
      <button type="button" aria-pressed={mode === "lot"} onClick={() => setMode("lot")}>Geçmiş üretim fişini incele</button>
    </div>
    <div hidden={mode !== "recipe"}><ProductionRecipeCostWorkspace planRows={props.planRows} planLabel={props.planLabel} planBasis={props.planBasis} /></div>
    {mode === "lot" && <><p className="pw-warning">Bu bölüm önceki fiş/lot hesaplamasıdır. Eski lot, kur ve kaynak bağlantıları ayrıca incelenmelidir; bugün üretim maliyeti için reçete hesabını kullanın.</p><ProductionLotCostWorkspace {...props} /></>}
  </div>;
}
